import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';

// Components
import { AppBarComponent } from '../components/app-bar/app-bar.component';
import { MenuComponent } from '../components/menu/menu.component';
import { NotFoundComponent } from '../components/not-found/not-found.component';
import { ConnectionBannerComponent } from '../components/connection-banner/connection-banner.component';

/**
 * Lo que comparten las páginas de eventos: barra, menú, banner de conexión y
 * "no encontrado". Los pipes y el ordenamiento de tablas del delivery se
 * fueron con sus pantallas.
 */
@NgModule({
    declarations: [
        AppBarComponent,
        MenuComponent,
        NotFoundComponent,
        ConnectionBannerComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        IonicModule,
        FormsModule,
    ],
    exports: [
        AppBarComponent,
        MenuComponent,
        NotFoundComponent,
        ConnectionBannerComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
